import { ActionParams } from './actions';
import { PrivacyPolicyType } from '@src/types';
import {
  getPrivacyPolicyPage,
  getPrivacyPolicyUrl,
  getPrivacyPolicyType,
  isCookiePolicyRequirementApproved,
} from '../selectors/app-settings';
import { validateUrl } from './utils/url-validation';
import { StoreState, Validation, Validations } from '../store';

export const validatePrivacyPolicy = ({ getState, setState }: ActionParams) => async (): Promise<Validations> => {
  const state = getState();
  await setState({
    validations: {
      ...getState().validations,
      privacyPolicyLink: validatePrivacyPolicyLink(state),
      reviewRequirements: validateReviewRequirements(state),
    },
  });

  return getState().validations;
};

const validateReviewRequirements = (state: StoreState) => {
  return isCookiePolicyRequirementApproved(state) ? 'valid' : 'invalid';
};

const validatePrivacyPolicyLink = (state: StoreState) => {
  const type = getPrivacyPolicyType(state);
  const page = getPrivacyPolicyPage(state);
  const url = getPrivacyPolicyUrl(state);
  let valid: Validation = 'valid';

  if (type === PrivacyPolicyType.PageOnSite && !page) {
    valid = 'invalid';
  } else if (type === PrivacyPolicyType.ExternalUrl && !validateUrl(url)) {
    valid = 'invalid';
  }
  return valid;
};

export interface ValidationActions {
  validatePrivacyPolicy(): Promise<Validations>;
}

export const initValidationActions = (actionParams: ActionParams): ValidationActions => ({
  validatePrivacyPolicy: validatePrivacyPolicy(actionParams),
});
